module.exports = __webpack_public_path__ + "static/media/guide-line-05.bc9afd27.svg";